import * as React from 'react'
import styled from 'styled-components'
import AudioReactRecorder, { RecordState } from 'audio-react-recorder'
import Modals from 'components/Modals'
import { I18n } from 'react-redux-i18n'
import { Button } from 'reactstrap'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'

const AudioRecorder = (props) => {
  const [hasPermissions, setHasPermissions] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')
  const [recordState, setRecordState] = React.useState(RecordState.NONE)
  const [audio, setAudio] = React.useState(null)
  const [trackAudio, setTrackAudio] = React.useState(undefined)

  React.useEffect(() => {
    const enableAudio = async () => {
      try {
        const audio = await navigator.mediaDevices.getUserMedia({ audio: true })
        setTrackAudio(audio.getAudioTracks()[0])
        setHasPermissions(true)
      } catch (error) {
        setErrorMessage('Por favor permita el uso del micrófono en su navegador')
      }
    }

    if (props.showAudioRecorder) {
      enableAudio()
    }

    if (trackAudio) {
      trackAudio.stop()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.showAudioRecorder])

  React.useEffect(() => {
    !props.uploading && discardAudio()
  }, [props.uploading])

  const startAudioRecording = () => {
    setRecordState(RecordState.START)
  }

  const stopAudioRecording = () => {
    setRecordState(RecordState.STOP)
  }

  //audioData contains blob and blobUrl
  const onStop = (audioData) => {
    setAudio(audioData)
  }

  const discardAudio = () => {
    setAudio(null)
  }

  const onToggleAudioRecorder = () => {
    setRecordState(RecordState.STOP)
    setTimeout(() => {
      setAudio(null)
    }, 200)
    props.onCloseModal(false)
  }

  return (
    <Modals
      isOpen={props.showAudioRecorder}
      toggle={onToggleAudioRecorder}
      contentClassName='modal-camera'
      backdrop={'static'}
      header={
        <div className='modal-wrapper-header'>
          <h1>{I18n.t('dashboard_record-voice-memo')}</h1>
          <span onClick={onToggleAudioRecorder}>
            <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close'/>
          </span>
        </div>
      }
      body={
        <AudioRecorderContainer>
          <Waveform>
            <AudioReactRecorder
              state={recordState}
              onStop={onStop}
              foregroundColor={'#E87721'}
              canvasWidth={532}
              canvasHeight={105}
            />
          </Waveform>
          { audio ?
            <AudioPlayerContainer>
              <audio controls src={audio.url} type="audio/wav"/>
              <Button color='primary' onClick={()=>{props.uploadAudio(audio)}} className='button-camera' disabled={props.uploading} style={{
                backgroundColor: '#E87721 !important',
                borderRadius: '27px !important',
                cursor: 'pointer',
                width: 54,
                height: 54,
              }}>
                { props.uploading ?
                  <Nixi1Spinner height='1.5em' width='1.5em'/> : 
                  <img src="https://assets.nixi1.dkv.es/chatweb/images/cloud-upload.svg" alt='icon'/>
                }
              </Button>
              <AudioRecorderButton color={'#E87721'} onClick={discardAudio}>
                <AudioRecorderIcon src={`https://assets.nixi1.dkv.es/chatweb/images/redo-alt-solid.svg`} />
              </AudioRecorderButton>
            </AudioPlayerContainer>
            :
            <>
              { hasPermissions ?
                <AudioRecorderButton color={'#E87721'} onClick={recordState === RecordState.START ? stopAudioRecording : startAudioRecording}>
                  <AudioRecorderIcon src={recordState === RecordState.START ? `https://assets.nixi1.dkv.es/chatweb/images/square-solid.svg` : `https://assets.nixi1.dkv.es/chatweb/images/microphone-white.svg`} />
                </AudioRecorderButton> :
                <ErrorMessage>{errorMessage}</ErrorMessage>
              }
            </>
          }
        </AudioRecorderContainer>
      }
    />
  )

}

export default AudioRecorder

const AudioRecorderContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 0.8;
  flex-direction: column;
  justify-content: center;
`

const Waveform = styled.div`
  background-color: #F4F4F4;
  border-radius: 4px;
  margin-bottom: 30px;
  width: 532px;
  height: 105px;
`

const AudioRecorderButton = styled.div`
  align-items: center;
  background-color: ${props => props.color};
  border-radius: 27px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  width: 54px;
  height: 54px;
`

const AudioRecorderIcon = styled.img`
  width: 29px;
  height: 29px;
`

const AudioPlayerContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 450px;
`

const ErrorMessage = styled.div`
  color: red;
  font-family: 'Raleway';
`
